import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CadouForWho() {
  const situations = ['Simți că viața ta poate fi mai bună, dar nu știi de unde să începi schimbarea și te lovești mereu de aceleași tipare.', 'Ai o relație complicată cu banii. Oricât ai munci, parcă nu e suficient și nu înțelegi de ce abundența vine greu spre tine.', 'Te simți blocată emoțional, anxioasă sau stresată și nu reușești să identifici singură ce anume te ține pe loc.', 'Ai citit cărți, ai meditat, ai fost la cursuri, dar fără ghidare constantă nimic nu s-a schimbat cu adevărat în viața ta.', 'Ești la un moment în viață în care simți că trebuie să faci o schimbare profundă, dar nu știi care e primul pas potrivit.', 'Vrei să afli dacă Academia de Abundență este potrivită pentru tine, înainte de a lua o decizie.'];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-284">
      <div className="max-w-6xl mx-auto px-6" data-id="element-285">
        <SectionHeading title="Această sesiune este pentru tine dacă..." data-id="element-286" />

        <div className="grid md:grid-cols-2 gap-5 mb-16" data-id="element-287">
          {situations.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: idx * 0.08
        }} className="flex gap-4 items-start bg-brand-cream p-6 md:p-7 rounded-2xl border border-brand-text/5 hover:shadow-warm transition-shadow" data-id="element-288">
              <div className="flex-shrink-0 mt-1 w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-289">
                <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-290" />
              </div>
              <p className="text-brand-text/85 leading-relaxed text-lg" data-id="element-291">
                {item}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-292">
          <CTAButton data-id="element-293" />
        </motion.div>
      </div>
    </section>;
}